var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReAdmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0319824 34V48.7397C0.0319824 59.3769 8.65509 68 19.2922 68H34.032H48.7717C59.4089 68 68.032 59.3769 68.032 48.7397V34V19.2603C68.032 8.62311 59.4089 0 48.7717 0H34.032H19.2922C8.6551 0 0.0319824 8.62311 0.0319824 19.2603V34Z",
    fill: "#FFF3D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7119 18.2539V49.5518H21.6233V48.2478C21.6233 47.5173 22.1969 46.9437 22.9274 46.9437C23.6579 46.9437 24.2315 47.5173 24.2315 48.2478V49.5518H33.3601V48.2478C33.3601 47.5173 33.9336 46.9437 34.6641 46.9437C35.3946 46.9437 35.9682 47.5173 35.9682 48.2478V49.5518H45.0968V48.2478C45.0968 47.5173 45.6704 46.9437 46.4009 46.9437C47.1314 46.9437 47.7049 47.5173 47.7049 48.2478V49.5518H55.5294V18.2539H13.7119Z",
    fill: "#FFDC8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5295 18.2539V49.5518H47.705V48.2478C47.705 47.5173 47.1314 46.9437 46.4009 46.9437C45.6704 46.9437 45.0968 47.5173 45.0968 48.2478V49.5518H35.9683V48.2478C35.9683 47.5173 35.3947 46.9437 34.6642 46.9437V18.2539H55.5295Z",
    fill: "#FEC53D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2723 33.9023H39.8805V36.5105H37.2723V33.9023Z",
    fill: "#FFDC8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4885 33.9023H45.0967V36.5105H42.4885V33.9023Z",
    fill: "#FFDC8A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7051 33.9023H50.3132V36.5105H47.7051V33.9023Z",
    fill: "#FFDC8A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2723 39.1172H50.3131V41.7253H37.2723V39.1172Z",
    fill: "#FFDC8A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8343 20.4742L49.0092 25.3254V21.6217L52.0085 18.6484L53.8343 20.4742Z",
    fill: "#FEC53D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5357 23.4688C23.3707 23.4688 21.6234 25.216 21.6234 27.381C21.6234 29.546 23.3707 31.2932 25.5357 31.2932C27.7006 31.2932 29.4479 29.546 29.4479 27.381C29.4479 25.216 27.7006 23.4688 25.5357 23.4688Z",
    fill: "#FEC53D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5355 31.293C21.9364 31.293 19.0151 34.2142 19.0151 37.8134V41.7256H32.0559V37.8134C32.0559 34.2142 29.1347 31.293 25.5355 31.293Z",
    fill: "#FEC53D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5356 31.2932V23.4688C27.7006 23.4688 29.4479 25.216 29.4479 27.381C29.4479 29.546 27.7006 31.2932 25.5356 31.2932Z",
    fill: "#FEC53D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.056 37.8134V41.7256H25.5356V31.293C29.1348 31.293 32.056 34.2142 32.056 37.8134Z",
    fill: "#FEC53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReAdmission);
export default __webpack_public_path__ + "static/media/reAdmission.39f0b1d5863d463dadaa10ee8bddaaae.svg";
export { ForwardRef as ReactComponent };